import React, { useRef } from "react";
import { Utils } from "../../../common/utils";
import { useValidate } from "formvalidation/hooks";
import { InputBase } from "components/Atoms/formInputs/InputBase";
import { CommonInputProps } from "./models";

interface Props extends CommonInputProps {
  focusOnMount?: boolean;
  emailCanBeBlank: boolean
  maxLength?: number;
  onEsc?: () => void;
  onEnter?: () => void;
  hideErrorLabel?: boolean;
}

const EmailInput = (props: Props) => {
  const ownRef = useRef<HTMLInputElement>(null);
  const inputRef = props.innerRef ?? ownRef;

  const validate = async (email: string) => {
    const isEmailEmpty = email.trim().length === 0;

    if (isEmailEmpty) {
      return props.emailCanBeBlank || (props.hideErrorLabel ? false : RESX.GeneralWarnings.PleaseFillInThisField);
    }

    const isEmailValid = Utils.isValidEmailAddress(email);

    if (!isEmailValid) {
      return props.hideErrorLabel ? false : RESX.GeneralLabels.EmailIsInvalid;
    }

    return true;
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.GeneralLabels.Email,
    value: props.value,
    validate: validate,
    ref: inputRef
  });

  return <InputBase
    ref={inputRef}
    type="email"
    focusOnMount={props.focusOnMount}
    placeholder={props.placeholder}
    maxLength={props.maxLength ?? serverReference.constants.mailAddress.maxEmailLength}
    error={validation.error.errorMessage ?? validation.error.hasError}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    onEnter={props.onEnter}
    onBlur={validation.validateAndSetError}
  />

};

export default EmailInput;
